import { useEffect } from 'react'
import { notifySuccessCustom } from '../../utils/notify'

export const BenefitsNotification = ({ active, message }) => {
  useEffect(() => {
    if (!active || !message) {
      return
    }

    notifySuccessCustom(message)
  }, [active, message])

  return null
}
